(function () {
    'use strict';
    angular
        .module('showcaseApp')
        .controller('InvoiceModalDetailController', InvoiceModalDetailController);

    function InvoiceModalDetailController(invoice, userProfile, paymentLinkEnabled, InvoicesService, $uibModalInstance, toastr, $translate, $localStorage, StoreService, $state, InvoiceUtilsService, systemConstants) {

        var vm = this;

        init();

        function init() {
            vm.invoice = invoice;
            vm.externalChannelLabel = InvoiceUtilsService.getExternalChannelLabel(invoice.externalChannel);
            vm.shippingOptionLabelKey = InvoiceUtilsService.getShippingOptionLabelKey(invoice.shippingMethod);
            vm.userProfile = userProfile;
            vm.paymentLinkEnabled = paymentLinkEnabled;
            vm.canCopyPaymentLink = InvoiceUtilsService.canCopyPaymentLink;
            vm.canRegeneratePaymentLink = InvoiceUtilsService.canRegeneratePaymentLink;
            vm.orders = [];
            vm.discounts = [];
            vm.subTotal = 0;
            vm.discount = 0;
            vm.hasDiscount = false;
            vm.isBrl = false;
            vm.cardDetails = null;
            vm.isImmoContext = $localStorage.defaultStore.immoContext;
            loadStore();
            loadDiscount();
            loadTransactionOrderList(vm.invoice.id)
            loadCardDetails();
        }

        function loadCardDetails() {
            if (vm.invoice.paymentCondition !== 'CREDIT_CARD') {
                return;
            }

            InvoicesService.getCardDetails(vm.invoice.id).then(function (result) {
                vm.cardDetails = result.data && result.data.lastFourDigits ? result.data : null;
            }, function () {
                vm.cardDetails = null;
            });
        }

        function loadDiscount() {
            if (vm.invoice && vm.invoice.discounts) {
                vm.discounts = vm.invoice.discounts.filter(function(item) {
                    return item.discountValueType != 'FREE_SHIPPING';
                });
                vm.discount = vm.invoice.discounts.filter(function(item) {
                        return item.discountValueType != 'FREE_SHIPPING';
                    })
                    .map(function(item) {
                        return item.calculatedDiscountValue;
                    })
                    .reduce(function(a, b) { return a + b},  0);
                vm.hasDiscount = vm.invoice.discounts.filter(function(item) {
                    return item.discountValueType != 'FREE_SHIPPING';
                }).length > 0;
            }
        }

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(function(response) {
                vm.storeCategory = response.data.categoryKey;
                vm.isBrl = response.data.langKey == 'pt-br';
            });
        }

        function loadTransactionOrderList(transactionId) {
            InvoicesService.getTransactionOrders(transactionId).then(function (result) {
                if (result.data) {
                    for (var i = 0; i < result.data.length; i++) {
                        var order = result.data[i];
                        if (!vm.isOrderNotReconciled(order)) {
                            order.size = order.size ? order.size : 'Padrão';
                            order.size = order.size.toUpperCase() === 'DEFAULT' ? 'Padrão' : order.size;
                        }
                        vm.orders.push(order);

                        if(order.discountedValue) {
                            vm.subTotal += (order.discountedValue * order.quantity);
                        } else {
                            vm.subTotal += (order.purchaseValue * order.quantity);
                        }
                    }
                }
            }, function (error) {
                vm.orders = [];
            });
        }

        vm.getPhoneNumber = function (phone) {
            return phone.includes('null') ? phone.split('null')[1] : phone.includes('+') ? phone.split('+')[1] : phone;
        }

        vm.getMaskedCard = function () {
            var brand = vm.cardDetails.brand ? vm.cardDetails.brand + ' ' : '';
            var firstSixDigits = vm.cardDetails.firstSixDigits || '';
            return brand + firstSixDigits + '******' + vm.cardDetails.lastFourDigits;
        }

        vm.getShippingValue = function() {
            return vm.invoice.shippingValue ? vm.invoice.shippingValue : 0;
        }

        vm.isOrderNotReconciled = function (order) {
            return order.status === systemConstants.NOT_RECONCILED_ORDER_STATUS;
        }

        vm.getDocumentType = function () {
            if (!vm.invoice.cpf) {
                return 'CPF';
            }

            return vm.invoice.cpf.length === 11 ? 'CPF' : 'CNPJ';
        }

        vm.printInvoice = function() {
            var idContainer = 'invoice-detail-modal';
            var originalContainer = document.getElementById(idContainer);

            var clone = originalContainer.cloneNode(true);

            var squares = clone.getElementsByClassName('color-square');

            for (var i = 0; i < squares.length; i++) {
                var color = squares[i].style.backgroundColor;
                if (color) {
                    squares[i].style.border = '11px solid ' + color;
                    squares[i].style.backgroundColor = color;
                }
            }

            var containerHtml = clone.innerHTML;
            var screenPrint = window.open('', '_blank', 'width=600,height=600');
            screenPrint.document.write('<!DOCTYPE html>\
            <head>\
                <link rel="stylesheet" type="text/css" href="/content/css/vendor.css" />\
                <link href="https://fonts.googleapis.com/css?family=Roboto:400,300,500,700|Montserrat|Cabin" rel="stylesheet">\
                <link rel="stylesheet" type="text/css" href="/content/css/main.css" />\
                <style>\
                    #btn-actions {display:none;}\
                    @media print {\
                        .text-navy {\
                            color: #2F0E7F !important;\
                            -webkit-print-color-adjust: exact;\
                        }\
                        .color-square {\
                            -webkit-print-color-adjust: exact !important;\
                            print-color-adjust: exact !important;\
                        }\
                    }\
                    h5, h4, p, table, th, address {\
                        font-size: 12px;\
                    }\
                    .printable-table {\
                        max-height: none !important;\
                    }\
                    .color-square {\
                        height: 22px;\
                        width: 22px;\
                        border-radius: 4px;\
                        display: inline-block; \
                        box-sizing: border-box;\
                    }\
                </style>\
            </head>\
            <body>' + containerHtml + '</body>\
            <script>\
                window.onload = function () {\
                setTimeout(function() {\
                    window.focus();\
                    window.print();\
                }, 1000);\
            };\
            </script>\
            </html>');
        }

        vm.cancelInvoice = function() {
            vm.isSaving = true;
            InvoicesService.updateTransactionStatus(vm.invoice.id, 'CANCELLED').then(function(result) {
                toastr.success($translate.instant('invoice.home.messages.saveSuccess'));
                vm.isSaving = false;
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error($translate.instant('invoice.home.messages.noItens'));
                vm.isSaving = false;
            });
        }

        vm.close = function() {
            $uibModalInstance.close();
        }

        vm.openRefundModal = function() {
            $uibModalInstance.close({ openRefundModal: true, invoice: invoice });
        }

        vm.copyPaymentLink = function() {
            InvoiceUtilsService.copyPaymentLink(vm.invoice.uuid);
        }

        vm.regeneratePaymentLink = function() {
            $uibModalInstance.close();
            $state.go('invoices.new', {
                cloneFromUuid: vm.invoice.uuid,
                cloneCustomerId: vm.invoice.customer ? vm.invoice.customer.id : null,
                cloneCustomerIdentity: vm.invoice.customer ? vm.invoice.customer.customerIdentity : null
            });
        }

        vm.maskPrice = function (value, currencyKey) {
            var currencyConfiguration = getCurrencyListConfiguration()[currencyKey];
            return formatMoney(value, currencyConfiguration.prefix, currencyConfiguration.decimalQuant, currencyConfiguration.centsSeparator, currencyConfiguration.thousandsSeparator);
        }

        vm.isValidColorHex = function (hex) {
            if (!hex) {
                return false;
            }
            return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
        };
    }
  })();
